/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetTransferPeerResponse,
  UtxTransferPeerGetTransferPeersParams,
  GetTransferPeerSchemaByTypeResponse,
  UtxTransferPeerGetTransferPeerSchemaByTypeParams,
  CreateTransferPeerResponse,
  CreateTransferPeerRequest,
  ValidateTransferPeerResponse,
  ValidateTransferPeerRequest,
  DeactivateTransferPeerResponse
} from './schema'



export const utxTransferPeerGetTransferPeers = (
    params?: UtxTransferPeerGetTransferPeersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetTransferPeerResponse>> => {
    return axios.get(
      `/transfer-peer`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransferPeerGetTransferPeersQueryKey = (params?: UtxTransferPeerGetTransferPeersParams,) => [`/transfer-peer`, ...(params ? [params]: [])];

    
export type UtxTransferPeerGetTransferPeersQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeers>>>
export type UtxTransferPeerGetTransferPeersQueryError = AxiosError<unknown>

export const useUtxTransferPeerGetTransferPeers = <TData = Awaited<ReturnType<typeof utxTransferPeerGetTransferPeers>>, TError = AxiosError<unknown>>(
 params?: UtxTransferPeerGetTransferPeersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransferPeerGetTransferPeersQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeers>>> = ({ signal }) => utxTransferPeerGetTransferPeers(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransferPeerGetTransferPeerSchemaByType = (
    params: UtxTransferPeerGetTransferPeerSchemaByTypeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetTransferPeerSchemaByTypeResponse>> => {
    return axios.get(
      `/transfer-peer/schema`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransferPeerGetTransferPeerSchemaByTypeQueryKey = (params: UtxTransferPeerGetTransferPeerSchemaByTypeParams,) => [`/transfer-peer/schema`, ...(params ? [params]: [])];

    
export type UtxTransferPeerGetTransferPeerSchemaByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeerSchemaByType>>>
export type UtxTransferPeerGetTransferPeerSchemaByTypeQueryError = AxiosError<unknown>

export const useUtxTransferPeerGetTransferPeerSchemaByType = <TData = Awaited<ReturnType<typeof utxTransferPeerGetTransferPeerSchemaByType>>, TError = AxiosError<unknown>>(
 params: UtxTransferPeerGetTransferPeerSchemaByTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeerSchemaByType>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransferPeerGetTransferPeerSchemaByTypeQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeerSchemaByType>>> = ({ signal }) => utxTransferPeerGetTransferPeerSchemaByType(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransferPeerGetTransferPeerSchemaByType>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransferPeerCreateTransferPeer = (
    createTransferPeerRequest: CreateTransferPeerRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateTransferPeerResponse>> => {
    return axios.post(
      `/transfer-peer/create`,
      createTransferPeerRequest,options
    );
  }



    export type UtxTransferPeerCreateTransferPeerMutationResult = NonNullable<Awaited<ReturnType<typeof utxTransferPeerCreateTransferPeer>>>
    export type UtxTransferPeerCreateTransferPeerMutationBody = CreateTransferPeerRequest
    export type UtxTransferPeerCreateTransferPeerMutationError = AxiosError<unknown>

    export const useUtxTransferPeerCreateTransferPeer = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxTransferPeerCreateTransferPeer>>, TError,{data: CreateTransferPeerRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxTransferPeerCreateTransferPeer>>, {data: CreateTransferPeerRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxTransferPeerCreateTransferPeer(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxTransferPeerCreateTransferPeer>>, TError, {data: CreateTransferPeerRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxTransferPeerValidateTransferPeer = (
    validateTransferPeerRequest: ValidateTransferPeerRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ValidateTransferPeerResponse>> => {
    return axios.post(
      `/transfer-peer/validate`,
      validateTransferPeerRequest,options
    );
  }



    export type UtxTransferPeerValidateTransferPeerMutationResult = NonNullable<Awaited<ReturnType<typeof utxTransferPeerValidateTransferPeer>>>
    export type UtxTransferPeerValidateTransferPeerMutationBody = ValidateTransferPeerRequest
    export type UtxTransferPeerValidateTransferPeerMutationError = AxiosError<unknown>

    export const useUtxTransferPeerValidateTransferPeer = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxTransferPeerValidateTransferPeer>>, TError,{data: ValidateTransferPeerRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxTransferPeerValidateTransferPeer>>, {data: ValidateTransferPeerRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxTransferPeerValidateTransferPeer(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxTransferPeerValidateTransferPeer>>, TError, {data: ValidateTransferPeerRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxTransferPeerDeactivateTransferPeer = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeactivateTransferPeerResponse>> => {
    return axios.post(
      `/transfer-peer/${id}/deactivate`,undefined,options
    );
  }



    export type UtxTransferPeerDeactivateTransferPeerMutationResult = NonNullable<Awaited<ReturnType<typeof utxTransferPeerDeactivateTransferPeer>>>
    
    export type UtxTransferPeerDeactivateTransferPeerMutationError = AxiosError<unknown>

    export const useUtxTransferPeerDeactivateTransferPeer = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxTransferPeerDeactivateTransferPeer>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxTransferPeerDeactivateTransferPeer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  utxTransferPeerDeactivateTransferPeer(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxTransferPeerDeactivateTransferPeer>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    